import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false // NOSONAR
})
export class ToolbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { // NOSONAR
  }

}
